import SquadSemiBoldItalicText from './SquadSemiBoldItalicText';

export default SquadSemiBoldItalicText;
